import { Link } from 'react-router-dom'
import { FileType, FILE_NAME, HELP_LINK } from './urlValidationUtils'
import Styles from './EmptyPreview.module.scss'
import { ReactComponent as PrivateIcon } from 'assets/icons/private16.svg'

type Props = {
  fileType: FileType
}

export const EmptyPreview = ({ fileType }: Props) => {
  const helpText = `Learn how to create an embed link in ${FILE_NAME[fileType]}`

  return (
    <div className={Styles.container}>
      <div className={Styles.icon}>
        <PrivateIcon />
      </div>
      <div className={Styles.header}>This link can't be embeded</div>
      <div className={Styles.text}>The link is incorrect, expired or not publicly accessible.</div>
      {fileType !== FileType.PDF && fileType !== FileType.DROPBOX && (
        <Link
          to={{ pathname: HELP_LINK[fileType] }}
          target="_blank"
          rel="noopener noreferrer nofollow ugc"
          className={Styles.link}
        >
          {helpText}
        </Link>
      )}
    </div>
  )
}
